export const equalityCheckNParamsCreator = <F extends Function>(number: number) =>
  (func: F): F => {
  let lastArgs: any[] = null
  let lastResult: any = null
  return ((...args : any[])  => {
    if (lastArgs === null || args.some((a, idx) => idx < number && a !== lastArgs[idx])) {
      lastResult = func(...args)
    }
    lastArgs = args
    return lastResult
  }) as any
}